webpackJsonp([127],{

/***/ "Qd8D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionMessagesSvc = (function () {
    function SubscriptionMessagesSvc() {
        this.status = '';
        this.message = '';
    }
    SubscriptionMessagesSvc.prototype.showSuccess = function (message) {
        this.message = message;
        this.status = 'success';
    };
    SubscriptionMessagesSvc.prototype.hideMassage = function () {
        this.status = '';
        this.message = '';
    };
    return SubscriptionMessagesSvc;
}());
exports.SubscriptionMessagesSvc = SubscriptionMessagesSvc;
angular.module('animatronApp.SubscriptionMessagesSvc', [])
    .service('subscriptionMessageSvc', SubscriptionMessagesSvc);


/***/ })

});


// WEBPACK FOOTER //
// javascripts/127-bd880478516a225297ea.min.js